export const GET_SENSORS_LIST = 'VARUNA.GET_SENSORS_LIST'
export const SEARCH_SENSORS = 'VARUNA.SEARCH_SENSORS'
export const SEARCH_SENSORS_CHEMICAL = 'VARUNA.SEARCH_SENSORS_CHEMICAL'
export const GET_SENSOR_DATA_RECORDS_LIST = 'VARUNA.GET_SENSOR_DATA_RECORDS_LIST'
export const GET_SENSOR_DATA_RECORD_TREND = 'VARUNA.GET_SENSOR_DATA_RECORD_TREND'
export const SELECT_SENSOR = 'VARUNA.SELECT_SENSOR'
export const GET_LATEST_SENSOR_CHEMICAL = 'VARUNA.GET_LATEST_SENSOR_CHEMICAL'
